import { ProductArrangementReassortmentType } from 'data/__generated__';

export const PRODUCT_ARRANGEMENT_REASSORTMENT_TYPE_LABELS: { [key in ProductArrangementReassortmentType]: string } = {
    [ProductArrangementReassortmentType.Manual]: 'Réassort Manuel',
    [ProductArrangementReassortmentType.Target]: 'Réassort par stock cible',
    [ProductArrangementReassortmentType.HotDrink]: 'Réassort Machine à café',
    [ProductArrangementReassortmentType.Tray]: 'Réassort Bac',
};
